module.exports = __webpack_public_path__ + "static/img/home3.05a3e61.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home3.webp
// module id = SgiQ
// module chunks = 3